import { Col, Divider, Row, Select } from 'antd5';
import styled from 'styled-components';

import { StyledTable } from 'components/DataTable/DataTable.style';
import { Alert, Modal } from 'components/ui';

export const StyledModal = styled(Modal)`
  .ant-modal-header {
    padding-bottom: 8px;
  }
  .ant-modal-body {
    padding: 0px;
  }
`;

export const TitleContainer = styled.div`
  .ant-steps {
    margin-top: 1rem;
    justify-content: center;
    width: 100%;
  }
`;

export const InspectionTypeSelector = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  padding: 0 24px 8px;
`;

export const ModalBody = styled.div`
  padding: 24px;
`;

export const LabelColumn = styled(Col)`
  margin-right: 0.5rem;
  padding-top: 0;
  text-align: right;

  > label {
    color: ${({ theme }) => theme.labelColor};

    span {
      color: ${({ theme }) => theme.red};
    }
  }
`;

export const FieldMappingRow = styled(Row)<{ $labelColumnWidth?: string }>`
  align-items: flex-start;
  column-gap: 0.5rem;
  display: grid;
  grid-template-columns: minmax(0, ${({ $labelColumnWidth }) => $labelColumnWidth ?? '45%'}) minmax(
      0,
      1fr
    );
`;

export const FieldMappingLabelColumn = styled(LabelColumn)`
  margin-right: 0;
  min-width: 0;
  white-space: normal;

  > label {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    line-height: 1.3;
    min-height: 32px;

    span {
      color: inherit;
    }

    .field-mapping-label-text {
      min-width: 0;
      overflow-wrap: anywhere;
    }

    .field-mapping-required-indicator {
      color: ${({ theme }) => theme.red};
    }
  }
`;

export const FieldMappingInputColumn = styled(Col)`
  min-width: 0;
`;

export const CheckboxFieldMappingInputColumn = styled(FieldMappingInputColumn)`
  align-items: center;
  display: flex;
  min-height: 32px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;

  button:not(:last-of-type) {
    margin-right: 0.5rem;
  }
`;

export const ConfigurationText = styled.p`
  > p.warning-text {
    color: ${({ theme }) => theme.red};
  }
`;

export const VerticalDivider = styled(Divider).attrs({ type: 'vertical' })`
  align-self: stretch;
  flex: none;
  height: auto;
  margin: 0 1rem;
`;

export const AutoReleaseStatusSelect = styled(Select)`
  &.ant-select-disabled .ant-select-selector {
    background: ${({ theme }) => theme.disabledBackground} !important;
    color: ${({ theme }) => theme.disabledTextColor} !important;
  }
`;

export const AdditionalInfoText = styled.p`
  font-size: 0.75rem;
  margin-top: 16px;
`;

export const ValidationTable = styled(StyledTable)`
  border: 1px solid ${({ theme }) => theme.borderColor};
  margin-bottom: 16px;

  .ant-pagination {
    margin-right: 16px;
  }

  td.ant-table-cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const StyledAlert = styled(Alert)`
  ${({ theme }) => {
    return `
      padding-bottom: 6px;
      padding-top: 6px;
      padding-left: 10px;
      margin-bottom: 10px;
      .ant-alert-description, .ant-alert-message {
        color: ${theme.descriptionColor}
      }
  `;
  }}
`;

export const WarningContainer = styled.div`
  margin: 1rem 0;
`;
